module.exports = __webpack_public_path__ + "img/nedaLogo.3510cb95.jpeg";